// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"2a7a4ce1","484":"5b614926","551":"26d4a21e"}[chunkId] + ".chunk.js";
};